module.exports = __webpack_public_path__ + "static/media/EyeTTTscreen2.05670fd2.png";